<template>
  <div class="wrapper bg_base base_container">
        <div class="container p-contact">
          <div class="content-center">
            <div class="row base_title">
              <div class="col-md-8 text-center ml-auto mr-auto">
                <h2 class="title">
                  AUDITION
                </h2>
                <h3>
                  オーディション
                </h3>
              </div>
            </div>
          </div>
          <div class="content_frame">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfzRk-_gmfqYLK84X5nanZjKg8gl8zqb_pkm21yiVUNAhx8Rw/viewform" target=”_blank”><img src="common/img/top/audition_banner.png" alt="audition"></a>
            <div>
              <h4 class="text-left">
                <br>
                ▼開催中のオーディションについて
              </h4>
              <ul class="contact-attention">
                <li>現在、「ASMR専門新VTuberグループ オーディション」を開催中です。</li>
                <li>※なお、他のオーディションは実施しておりませんのでご注意ください。</li>
                <li><strong>【ASMR専門新VTuberグループ オーディションについて】</strong></li>
                <li>トリリオンステージの系列グループとして、新たに「ASMR専門」のアイドルVTuberグループが設立されます。</li>
                <li>その第一期メンバーを、広く募集いたします</li>
                <li>ASMRの活動実績がなくとも、「光る個性」が宿っている方をトリステは歓迎いたします。</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                <br>
                ▼「ASMR専門新アイドルVTuberグループ」とは？
              </h4>
              <ul class="contact-attention">
                <li><strong>「トラウマが、その花を美しく咲かせる」</strong></li>
                <li>悲しい経験、トラウマ、コンプレックス──</li>
                <li>痛みを知り、過去に傷跡を負うものだからこそ、世界へ最高の癒やしを届けられると信じています。</li>
                <li>あなたが魅力的なのは、誰よりも痛みを負ってきたから。</li>
                <li>新グループは</li>
                <li>「コンプレックスは最大の武器だ」を理念に掲げるトリリオンステージの魂を継いだ、</li>
                <li>トラウマを最高の魔法に変える、ASMR専門のアイドルVTuberグループとなります。</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                <br>
                ▼ 活動内容
              </h4>
              <ul class="contact-attention">
                <li>トリリオンステージの「ASMR特化」版です</li>
                <li>・ASMRを中心に配信、動画投稿</li>
                <li>・個人での活動のみならず、グループとしてコラボASMRなどの作成</li>
                <li>・活動の進展、それぞれの個性に合わせて楽曲の歌唱等</li>
                <li>ASMRで癒やしを届けながらもいつかはステージで輝く、異色のアイドルを目指した活動です。</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                <br>
                ▼選考の流れ
              </h4>
              <ul class="contact-attention">
                <li>選考の大まかな流れになります（変更の可能性がございます）</li>
                <li>1次選考：オンライン応募による書類＆動画選考</li>
                <li>2次選考：Discordを通じたオンライン面接</li>
                <li>3次選考：実技試験（ない場合もございます）</li>
                <li>4次選考：最終面接（オンライン予定）</li>
                <li>　　　　　↓</li>
                <li>VTuberとしてデビュー！</li>
                <li>トリリオンステージが展開する「ASMR専門新VTuberグループ」の第一期生として活動して頂きます！</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                ▼応募要項
              </h4>
              <ul class="contact-attention">
                <li>応募に関しての必須要件となります</li>
                <li>・ASMRへの活動に意欲的な方</li>
                <li>・2年間以上継続的に、週4回以上配信が可能な方</li>
                <li>・合格後2ヶ月以内に活動開始が可能な方（応相談）</li>
                <li>・活動に対し強い向上心と積極性を持つ方</li>
                <li>・チームワークとルールを守れる方</li>
                <li>・適切な配信環境を構築可能な方（機械が苦手など、技術面に関しては事務所にてサポート致します）</li>
                <li>・ASMRに意欲的な方</li>
                <li>・健康やメンタル面に不安の無い方</li>
                <li>「ASMR専門新アイドルVTuberグループ」はメインチャンネルにてASMRを中心に</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                ▼歓迎するスキル
              </h4>
              <ul class="contact-attention">
                <li>応募に関しての歓迎要件となります（満たしていなくても応募は可能です）</li>
                <li>・ASMRを聞くのも実施するのも大好きな方</li>
                <li>・セクシーなことが大好きな方(活動内容にR-18はございません)</li>
                <li>・配信活動、創作活動などの実績がある方</li>
                <li>・とても尖ったパーソナリティや趣味をお持ちで、それを披露することに抵抗のない方</li>
                <li>・個人の成功のみならず、チームでの成功に魅力を感じる方</li>
                <li>・自発的に企画内容を考案する能力に長けてる方</li>
                <li>・希少なスキルや特技をお持ちの方（楽器演奏、特定のゲームのランクが高い、マニアックな事柄への造形が深いなど）</li>
                <li>※VTuberとして活動中の方も歓迎しております</li>
                <li>※ASMRに無関係な尖った個性も歓迎しております</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                ▼注意事項
              </h4>
              <ul class="contact-attention">
                <li>必ずお読みください</li>
                <li>・応募前に応募要項を必ずご確認ください</li>
                <li>・第一次選考は通過者の方にのみご連絡します（原則2週間以内にご返信致します）</li>
                <li>・オーディションに参加され得た情報は機密情報となります。（発信されないようにご注意ください）</li>
                <li>・公平性の観点を鑑みて、審査内容の詳細についてお答えすることはできません</li>
                <li>・ご入力いただいた情報は、弊社<a href="https://trillionstage.jp/#/about/privacy">プライバシーポリシー</a>に従って適切に処理致します</li>
              </ul>
            </div>
            <div>
              <h4 class="text-left">
                ▼応募
              </h4>
              <ul>
                <li>下記のリンクから応募ページにアクセスし、応募フォームを記入してください。</li>
                <li>各自のパーソナリティと才能を思う存分に発揮していただき、一緒に成長してくださることを楽しみにしております。</li>
              </ul>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfzRk-_gmfqYLK84X5nanZjKg8gl8zqb_pkm21yiVUNAhx8Rw/viewform" target=”_blank” style="line-height: 7;"><img src="common/img/top/oubo_button.png" alt="audition"></a>
              <!-- add some new lines to avoid the button affacted by page footer under narrow screen devices -->
              <br><br><br><br>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
  import { Card, Button, Comment, Checkbox } from '@/components';

  export default {
    name: 'BlogPost',
    bodyClass: 'blog-post',
    components: {
      Card,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        form: {
          comment: ''
        },
      }
    }
  }
</script>
<style>
</style>
